export const CANDIDATE_FORM_UI = {
    organization_title: 'Watchguard Technologies',
    start_test: 'Start Test',
    clear_test: 'Clear',
    camera_permission: 'Give Camera Permission to Start Test',
    instruction_confirmation: 'I have read and understood all instructions.',
    test_name: 'Test Name',
    email: 'Email',
    password: 'Test Password',
    read_instruction: 'Please confirm by clicking on checkbox that you have read and understood all instructions before proceeding by scrolling the instructions.'
}

export const VERIFY_UI = {
    organization_title: 'Watchguard Technologies',
    organization_description: 'WatchGuard\'s Unified Security Platform is built from the ground up to enable efficient, powerful security services with increased scale and velocity while gaining operational efficiencies.WatchGuard\'s unified approach makes it easy to deploy and manage the breadth of products and services you need to modernize, mature, and scale your security in the face of today’s increasingly complex threat landscape.',
    verify_test: 'Verify',
    clear_test: 'Clear',
    verify_message: 'Enter the verification code sent to your registered email to start the test',
    note_message: `Note: Didn't receive a code? Contact your administrator`,
    test_code: 'Test Code'
}

export const CONFIRM_SUBMIT_UI = {
    total_questions: 'Total Questions',
    attempted: 'Attempted',
    unanswered: 'Unanswered',
    quiz_statistics: 'Test Statistics',
    finish_test: 'Finish Test',
    info: 'After clicking on Finish Test your test will submit and you will not be able to start again.'
}

export const QUESTION_PAGE_UI = {
    next: 'Submit and Next',
    submit_test: 'Submit Answer',
    clear_selection: 'Clear Selection',
    clear_answer: 'Clear Answer',
    review: 'Mark for Review',
    clear_review: 'Clear Review Flag',
    exit_full_screen_message: 'Are you sure you want to exit fullscreen!\n\
        If you exit fullscreen you test will get submitted.\n',
    exit_full_screen_header: 'Confirm fullscreen exit',
    exit_test_message: 'This will exit your test. Are you sure you want to exit?',
    exit_test_header: 'Confirm test exit',
    multi_answer: 'Multiple answer allowed',
    correct_mark: 'Correct +1',
    disclaimer_label: 'Disclaimer: ',
    disclaimer_info: 'You need to submit test after attempting all questions otherwise your response will not be saved.'
}

export const TEST_NAVBAR_UI = {
    tab_count: 'Tab Count',
    submit: 'Submit Test',
    instruction: 'Instructions',
    time_remaining: 'Time Remaining:'
}

export const TEST_INSTRUCTION = {
    heading: 'Instructions for Candidates',
    device_requirement: 'A laptop/desktop with a stable and high-speed internet connection is mandatory.',
    camera_instruction: `This test is proctored. Your web camera must remain active throughout, with your face clearly visible at all times. Non-compliance will lead to cancellation of your candidature.`,
    fullscreen_instruction: `The test must be taken in full-screen mode. Exiting full-screen will auto-submit the test.`,
    tabswitch_instruction_heading: `Tab Switching is strictly prohibited`,
    tabswitch_instruction_second: `Tab switches will auto-submit the test and disqualify the candidate.`,
    save_answer: 'Click the “Submit and Next” button after each question to ensure your answer is saved.',
    test_time_window: 'The test link is valid only during your assigned time slot.',
    termination_warning: 'Exiting the test window even once may lead to termination.',
    mark_review: `🚩 icon shows mark review questions.`,
    unanswered_with_markreview_instruction: `+ 🚩 - Unanswered and Marked for Review`,
    answered_instruction: `- Answered`,
    unanswered_instruction: `- Unanswered`,
    color_instruction: `Color indicators:`,
    instruction_confirmation: ' I have read and understood all instructions.',
    continue_message: 'Click on confirm box for start the test.'
}

export const WARNING_UI = {
    heading: 'Warning',
    tab_switch_attempt: 'We noticed you switched tabs during the test. ',
    auto_submit: 'Any further attempts may result in the automatic termination of your test and disqualification.',
}

export const QESTION_PAGE_UI = {
    disclaimer: 'Disclaimer: -',
    info: 'You need to submit test after attempting all question otherwise your response will not saved',
    camera_on:'Please Turn On Web Cam'
}

export const CANDIDATE_DETAIL_UI = {
    error_message: {
        name_required: 'name is required.',
        number_required: 'mobile no is required.',
        number_invalid: 'mobile no is invalid.',
        cgpa_required: 'cgpa is required.',
        cgpa_invalid: 'cgpa is invalid.',
        resume_required: 'resume is required.',
        resume_invalid_type: 'Please upload a PDF file only',
        resume_too_large: 'File size must be less than 1MB',
        resume_invalid: 'Invalid Resume',
        college_name_required: 'College name is required'
    },
    resume_instruction: 'Please upload the resume (pdf format less than 1MB) which is mandatory to be uploaded during the start of the Online Written Test.',
    note_message: `Note: Contact your administrator for any query.`,
    upload_resume: 'Upload',
    upload_message: 'Upload Resume (.pdf)',
    change_message: 'Change Resume (.pdf)',
    next: 'Save & Next',
    name: 'Name',
    college_name: 'College Name',
    mobile: 'Mobile No',
    cgpa: 'GPA',
}

export const ERROR_MESSAGE = {
    unauthorized_summary: 'Unauthorized',
    unauthorized_msg: 'Please check your code.'
}
